import { useState } from "react";

export const useHelpDelete = () => {
  const [confirmOpen, setConfirmOpen] = useState<boolean>(false);
  const [pendingDeleteId, setPendingDeleteId] = useState<string | null>(null);

  const openDeleteConfirm = (id: string) => {
    setPendingDeleteId(id);
    setConfirmOpen(true);
  };

  const closeDeleteConfirm = () => {
    setConfirmOpen(false);
    setPendingDeleteId(null);
  };

  const getPendingDeleteId = () => pendingDeleteId;

  return {
    confirmOpen,
    openDeleteConfirm,
    closeDeleteConfirm,
    getPendingDeleteId,
  };
};
